module.exports = __webpack_public_path__ + "img/Monte_Kope_9.7461b7bb.jpg";